import React from 'react';
import cn from 'clsx';
import { lowerBoundsBreakpoints, strictBreakpoints } from 'common/styles/breakpoints';
import { bannerLogo, bannerLogoWrapper } from './banner-media-styles';

export type BannerMediaProps = {
  srcD: string;
  srcT: string;
} & JSX.ReactHTMLImageElement;

export const BannerMedia: React.FC<BannerMediaProps> = ({
  alt,
  className,
  srcD,
  srcT,
  src,
  width = 144,
  height = 96,
}) => (
  <div className={bannerLogoWrapper}>
    <picture>
      <source srcSet={srcD} media={lowerBoundsBreakpoints['--from-desktop']} />
      <source srcSet={srcT} media={strictBreakpoints['--only-tablet']} />
      <img alt={alt} className={cn(bannerLogo, className)} src={src} width={width} height={height} />
    </picture>
  </div>
);
